import LogicTab from './LogicTab';
import { LogicTabProps, LogicTabValueProps } from './types';

export type { LogicTabProps, LogicTabValueProps };
export default LogicTab;
